(function () {
  function init(swiperEl) {
    if (swiperEl.dataset.thumbSyncWired === '1') return;
    var swiper = swiperEl.swiper;
    if (!swiper) return;

    var extras = swiperEl.parentElement.querySelector(':scope > .carousel-thumbnails-extras');
    var thumbsRoot = extras ? extras.querySelector('.product-thumbnails') : null;
    var counterCurrent = extras ? extras.querySelector('#product-image-current') : null;
    var counterTotal = extras ? extras.querySelector('#product-image-total') : null;

    var thumbButtons = thumbsRoot
      ? Array.prototype.slice.call(thumbsRoot.querySelectorAll('[data-product-thumbnail]'))
      : [];
    if (!thumbButtons.length && !counterCurrent) return;

    swiperEl.dataset.thumbSyncWired = '1';

    // Build id→index from ORIGINAL slides only (skip Swiper loop duplicates).
    var slides = Array.prototype.slice.call(
      swiperEl.querySelectorAll('.swiper-slide[data-media-item-id]')
    ).filter(function (s) {
      return !s.classList.contains('swiper-slide-duplicate');
    });
    var idToIndex = {};
    slides.forEach(function (slide, i) {
      idToIndex[slide.dataset.mediaItemId] = i;
    });

    // Counter total should reflect actual slides in the carousel (variant-filtered),
    // not product.media.size from Liquid.
    if (counterTotal) counterTotal.textContent = String(slides.length);

    // theme.js's switchImage adds .hidden to every [data-product-media-wrapper] that
    // isn't the new featured one. In carousel mode those wrappers ARE the swiper
    // slides, so all slides except the new featured one get hidden — Swiper breaks.
    // Strip .hidden off all slides after a variant change.
    function unhideAllSlideImages() {
      swiperEl.querySelectorAll('.swiper-slide.hidden, .swiper-slide [data-product-media-wrapper].hidden')
        .forEach(function (el) { el.classList.remove('hidden'); });
    }

    var suppressObserver = false;

    function setActive(index) {
      suppressObserver = true;
      thumbButtons.forEach(function (btn) {
        var slideIdx = idToIndex[btn.dataset.thumbnailId];
        if (slideIdx === index) {
          btn.classList.add('active');
          if (typeof btn.scrollIntoView === 'function') {
            btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        } else {
          btn.classList.remove('active');
        }
      });
      if (counterCurrent) counterCurrent.textContent = String(index + 1);
      // Defer reset so the observer's microtask sees suppressObserver=true.
      setTimeout(function () { suppressObserver = false; }, 0);
    }

    function slideToIndex(idx) {
      if (idx == null) return;
      var current = swiper.realIndex != null ? swiper.realIndex : swiper.activeIndex;
      if (idx === current) {
        unhideAllSlideImages();
        return;
      }
      if (swiper.params && swiper.params.loop) {
        swiper.slideToLoop(idx);
      } else {
        swiper.slideTo(idx);
      }
      unhideAllSlideImages();
    }

    thumbButtons.forEach(function (btn) {
      btn.addEventListener(
        'click',
        function (e) {
          var idx = idToIndex[btn.dataset.thumbnailId];
          if (idx == null) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          slideToIndex(idx);
        },
        true
      );
    });

    // When variant changes, theme.js (_switchCurrentImage) adds .active to the new
    // featured-media thumbnail and runs switchImage on the swiper wrapper. Hook into
    // that by watching the .active class on each thumb button — when an .active lands
    // that doesn't match the current swiper slide, drive the carousel there.
    var thumbsObserver = new MutationObserver(function (mutations) {
      if (suppressObserver) return;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'attributes' || m.attributeName !== 'class') continue;
        var btn = m.target;
        if (!btn.classList.contains('active')) continue;
        var idx = idToIndex[btn.dataset.thumbnailId];
        if (idx == null) continue;
        slideToIndex(idx);
        break;
      }
    });
    thumbButtons.forEach(function (btn) {
      thumbsObserver.observe(btn, { attributes: true, attributeFilter: ['class'] });
    });

    swiper.on('slideChange', function () {
      var idx = swiper.realIndex != null ? swiper.realIndex : swiper.activeIndex;
      setActive(idx);
    });

    setActive(swiper.realIndex != null ? swiper.realIndex : swiper.activeIndex);
    unhideAllSlideImages();
  }

  function tryInitAll() {
    document
      .querySelectorAll('.product__media-container.below-mobile.carousel.swiper')
      .forEach(function (el) {
        if (el.swiper) init(el);
      });
  }

  function watch() {
    tryInitAll();
    var observer = new MutationObserver(tryInitAll);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
